import RestService from './RestService'

export default class FilterService extends RestService {
    constructor() {
        super('filters')
    }
}